/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import type { StackSlots, StackState } from "./Stack.types";
import { assertSlots } from "@fluentui/react-components";

export const renderStack = (state: StackState) => {
  assertSlots<StackSlots>(state);

  return (
    <state.root>
      {state.wrap ? (
        <state.inner>{state.children}</state.inner>
      ) : (
        state.children
      )}
    </state.root>
  );
};
